import { render, staticRenderFns } from "./AppReviewOverlayInfoTotal.vue?vue&type=template&id=a10a1f5a&scoped=true"
import script from "./AppReviewOverlayInfoTotal.vue?vue&type=script&lang=js"
export * from "./AppReviewOverlayInfoTotal.vue?vue&type=script&lang=js"
import style0 from "./AppReviewOverlayInfoTotal.vue?vue&type=style&index=0&id=a10a1f5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a10a1f5a",
  null
  
)

export default component.exports